
import { SHOW_MODAL_ADDITIONAL_DATA } from './services/actions'
import { CHECK_NON_FORFAIT_TOKEN_FAILURE, CHECK_NON_FORFAIT_TOKEN_SUCCESS, STOP_CHECKOUT_LOADING,SAVE_QUERY_PARAMS } from './types';

const INITIAL_STATE = {
  tokenStatus: null,
  error: null,
  validNonForfaitToken: null,
  nonForfaitBudget: null,
  nonForfaitAutocareBudget: null,
  queryParams: {
    make: null,
    zipCode: null,
    model: null,
  },
}

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case CHECK_NON_FORFAIT_TOKEN_FAILURE:
      return {
        ...state,
        tokenStatus: action.payload.status,
        error: action.payload.error,
        validNonForfaitToken: false,
      }
    case CHECK_NON_FORFAIT_TOKEN_SUCCESS:
      return {
        ...state,
        tokenStatus: action.payload.status,
        validNonForfaitToken: true,
        nonForfaitBudget: action.payload.budget,
        nonForfaitAutocareBudget: action.payload.autocareBudget
      }
    case STOP_CHECKOUT_LOADING:
      return {
        ...state,
        tokenStatus: 'notValidate',
      }

    case SAVE_QUERY_PARAMS:
      return {
        ...state,
        queryParams: action.queryParams,
      }
    default:
      return {
        ...state,
      }
  }
}



// WEBPACK FOOTER //
// ./src/workflow/checkout/reducer.js